import ModalShell from './ModalShell';
import { useTranslation } from '../../hooks/useTranslation';
import { formatDateTime } from '../../utils/format';

const ChangeLogsModal = ({ user, logs, loading, onClose }) => {
  const { t } = useTranslation();
  return (
    <ModalShell
      title={t('users.changeLogsTitle', { username: user.username })}
      size="lg"
      onClose={onClose}
      footer={
        <button className="btn btn-secondary" onClick={onClose}>{t('common.cancel')}</button>
      }
    >
      <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        {loading ? (
          <div className="text-center py-3"><div className="spinner-border spinner-border-sm" role="status"></div></div>
        ) : logs.length === 0 ? (
          <p className="text-muted text-center">{t('common.noData')}</p>
        ) : (
          <table className="table table-sm table-bordered">
            <thead className="table-secondary">
              <tr>
                <th style={{ whiteSpace: 'nowrap' }}>{t('users.logTime')}</th>
                <th>{t('users.logOperator')}</th>
                <th>{t('users.logAction')}</th>
                <th>{t('users.logChanges')}</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, i) => (
                <tr key={i}>
                  <td style={{ whiteSpace: 'nowrap', fontSize: '0.85rem' }}>
                    {formatDateTime(log.created_at)}
                  </td>
                  <td>{log.operator}</td>
                  <td><span className="badge bg-secondary">{log.action}</span></td>
                  <td style={{ fontSize: '0.85rem' }}>
                    {log.changes && Object.entries(log.changes).map(([field, val]) => (
                      <div key={field}>
                        <strong>{field}</strong>: <span className="text-danger">{String(val.old || '-')}</span> → <span className="text-success">{String(val.new || '-')}</span>
                      </div>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </ModalShell>
  );
};

export default ChangeLogsModal;
